import { Checkbox, TableHead, TableRow } from "@mui/material";
import { useBatchContractSweepPreviewContext } from "src/views/AssetManagement/BatchContractSweep/contexts";
import {
  areAllAddressesSelected,
  setAllAddressesSelection,
} from "./helpers/selectionHelpers";
import { TABLE_COLUMNS } from "./constants/tableColumns";
import OverflowTooltipText from "src/components/OverflowTooltipText";
import StyledTableCell from "./components/StyledTableCell";

function TableHeader() {
  const {
    sendingAddressesMap,
    setSendingAddressesMap,
    translate: t,
  } = useBatchContractSweepPreviewContext();

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSendingAddressesMap((prev) =>
      setAllAddressesSelection(prev, event.target.checked),
    );
  };

  return (
    <TableHead sx={{ background: "#fff" }}>
      <TableRow>
        {TABLE_COLUMNS.map((column) => (
          <StyledTableCell
            key={column.id}
            sx={{ color: "#a2a2a2" }}
            align={"center"}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <OverflowTooltipText text={t(column.labelKey)} />
              {column.id === "select_all" && (
                <Checkbox
                  checked={areAllAddressesSelected(sendingAddressesMap)}
                  onChange={handleSelectAll}
                />
              )}
            </div>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default TableHeader;
